import { render, staticRenderFns } from "./ChatInternal.vue?vue&type=template&id=043bbf8c&scoped=true"
import script from "./ChatInternal.vue?vue&type=script&lang=js"
export * from "./ChatInternal.vue?vue&type=script&lang=js"
import style0 from "./ChatInternal.vue?vue&type=style&index=0&id=043bbf8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043bbf8c",
  null
  
)

export default component.exports